import React from 'react';
import { CheckCircle } from 'lucide-react';

import haccp from '../assets/images/certificaciones/HACCP-removebg-preview.png';
import globalstd from '../assets/images/certificaciones/fssc.png';
import primusgfs from '../assets/images/certificaciones/primus.png';  
import fda from '../assets/images/certificaciones/fda.png';

const Certificaciones = () => {
  const certifications = [
    {
      id: 1,
      name: "GlobalSTD",
      // description: "Se obtuvo en 2021",
      image: globalstd,
      color: "from-blue-500 to-blue-700",
      delay: "0s"
    },
    {
      id: 2,
      name: "HACCP",
      // description: "Se obtuvo en 2011",
      image: haccp,
      color: "from-green-500 to-green-700",
      delay: "0.2s"
    },
    {
      id: 3,
      name: "Primus GFS",
      // description: "Se obtuvo en 2011",
      image: primusgfs,
      color: "from-purple-500 to-purple-700",
      delay: "0.4s"
    },
    {
      id: 4,
      name: "FDA",
      // description: "Se obtuvo en 2020.",
      image: fda,
      color: "from-red-500 to-red-700",
      delay: "0.6s"
    }
  ];  return (
    <div className="bg-white py-16 px-8">
      {/* Header con animación */}
      <div className="text-center mb-12 animate-fade-in">
        <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-green-900 via-green-900 to-green-900 bg-clip-text text-transparent mb-6">
         Nuestras Certificaciones
        </h1>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
          Nuestro compromiso con la calidad se refleja en las certificaciones internacionales más prestigiosas, 
          garantizando los más altos estándares en cada proceso.
        </p>
      </div>      {/* Certificación Principal - GlobalSTD */}
      <div className="mb-16">
        <div className="max-w-xl mx-auto">
          <div className="text-center transform hover:scale-105 transition-transform duration-300">
            <div className="mb-6">
              <img 
                src={globalstd} 
                alt="GlobalSTD"
                className="w-32 h-32 md:w-40 md:h-40 object-contain mx-auto drop-shadow-lg filter grayscale-0"
              />
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-blue-800 mb-3">
              GlobalSTD
            </h2>
            {/* <p className="text-base text-blue-700 mb-4 font-semibold">
            Obtenida en 2021
            </p> */}
            <div className="inline-flex items-center justify-center bg-blue-600 text-white px-4 py-2 rounded-full font-semibold">
              <CheckCircle className="w-5 h-5 mr-2" />
              Certificación Destacada
            </div>
          </div>
        </div>
      </div>

      {/* Otras Certificaciones */}
      {/* <div className="text-center mb-8">
        <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
          Otras Certificaciones de Calidad
        </h3>
      </div> */}

      {/* Grid de certificaciones restantes */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 max-w-4xl mx-auto">
        {certifications.filter(cert => cert.name !== 'GlobalSTD').map((cert) => (
          <div
            key={cert.id}
            className="group text-center flex flex-col items-center justify-start h-full"
            style={{
              animationDelay: cert.delay,
              animation: `slideInUp 0.8s ease-out ${cert.delay} both`
            }}
          >
            {/* Logo de la certificación */}
            <div className="mx-auto mb-6 flex items-center justify-center h-32 w-32">
              <img 
                src={cert.image} 
                alt={cert.name}
                className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 object-contain group-hover:scale-110 transition-transform duration-300 filter grayscale group-hover:grayscale-0"
              />
            </div>

            {/* Nombre de la certificación */}
            <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-3 group-hover:text-green-600 transition-colors duration-300 min-h-[3rem] flex items-center">
              {cert.name}
            </h3>
            
            {/* Descripción breve */}
            {/* <p className="text-sm text-gray-600 leading-relaxed mb-4 group-hover:text-gray-700 transition-colors duration-300 flex-grow">
              {cert.description.split('.')[0]}.
            </p> */}

            {/* Indicador de verificación */}
            <div className="flex items-center justify-center text-green-500 text-sm mt-auto">
              <CheckCircle className="w-4 h-4 mr-2" />
              <span className="font-medium">Verificada</span>
            </div>
          </div>))}
      </div>      {/* Footer con estadísticas - Estilo Empresarial */}
      {/* <div className="mt-16 border-t border-gray-200 pt-8">
        <div className="flex flex-col md:flex-row justify-center items-center space-y-6 md:space-y-0 md:space-x-12">
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 mb-2">4+</div>
            <div className="text-sm text-gray-600 uppercase tracking-wide font-medium">Certificaciones</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 mb-2">100%</div>
            <div className="text-sm text-gray-600 uppercase tracking-wide font-medium">Compliance</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-green-600 mb-2">Global</div>
            <div className="text-sm text-gray-600 uppercase tracking-wide font-medium">Reconocimiento</div>
          </div>
        </div>
      </div> */}
      
    </div>
  );
};

export default Certificaciones;